<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="87px" label-position='right' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="俱乐部名" label-width="87px" )
                    el-input.inputWidth( v-model='dataForm.name' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="会长姓名" label-width="87px")
                    el-input.inputWidth(v-model='dataForm.chairman' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="会长账号" )
                    el-input.inputWidth(v-model='dataForm.chairmanId' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="俱乐部等级"  label-width="90px" )
                    el-select.inputWidth( v-model="dataForm.level" clearable )
                        el-option(label="甲A" :value="1")
                        el-option(label="甲B" :value="2")
                        el-option(label="乙A" :value="3")
                        el-option(label="乙B" :value="4")
                        el-option(label="丙A" :value="5")
                        el-option(label="丙B" :value="6")
                        el-option(label="丁A" :value="7")
                        el-option(label="丁B" :value="8")
                        el-option(label="资格甲" :value="9")
                        el-option(label="资格乙" :value="10")
                        el-option(label="资格丙" :value="11")
                        el-option(label="资格丁" :value="12")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='俱乐部积分' label-width="90px")
                  el-input-number(v-model='dataForm.startScore',:min='startScoreMin',:max='StartScoreMax',@change='strHandleChange',style='width:80px;')
                  font &nbsp;&nbsp;至&nbsp;&nbsp;
                  el-input-number(v-model='dataForm.endScore', :min='startScoreMin',:max='StartScoreMax' @change="endHandleChange" style='width:80px;',)
              el-col(:md='6' :sm="12" style='margin-left:12px;')
                el-form-item(label="注册时间" label-width="75px")
                    el-date-picker(style='width:210px'  v-model='dataForm.publishTime'  range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
              el-col(:md='6' :sm="12")
                el-form-item(label="地区" label-width="72px" )
                  el-select(v-model="dataForm.proviceId" placeholder="全国" @change="changeProvice"  multiple clearable)
                    el-option(v-for="(item,index) in proviceList" :key="index" :label="item.name" :value="item.proviceId")
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle()'  type='primary' v-if="isAuth('ct:clubManage:add')" ) 新建
                el-button(@click="exportExcel()"  type='primary' v-if="isAuth('ct:clubManage:download')"  ) 导出
                el-button(@click="deleteItem()"  type='danger' v-if="isAuth('ct:clubManage:download')" :disabled='checkedItems.length<=0' ) 删除
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='getDataList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading'  @selection-change="handleSelectionChange" border)
            el-table-column(type='selection',header-align='center',align='center')
            el-table-column(prop='name',header-align='center',align='center',label='俱乐部名称')
            el-table-column(prop='cityName',header-align='center',align='center',label='地区')
            el-table-column(prop='chairman',header-align='center',align='center',label='会长' )
            el-table-column(prop='chairmanId',header-align='center',align='center',label='会长账号')
            el-table-column(prop='level',header-align='center',align='center',label='俱乐部等级' )
                template(slot-scope='scope')
                    font(v-if='scope.row.level === 1') 甲A
                    font(v-if='scope.row.level === 2') 甲B
                    font(v-if='scope.row.level === 3') 乙A
                    font(v-if='scope.row.level === 4') 乙B
                    font(v-if='scope.row.level === 5') 丙A
                    font(v-if='scope.row.level === 6') 丙B
                    font(v-if='scope.row.level === 7') 丁A
                    font(v-if='scope.row.level === 8') 丁B
                    font(v-if='scope.row.level === 9') 资格甲
                    font(v-if='scope.row.level === 10') 资格乙
                    font(v-if='scope.row.level === 11') 资格丙
                    font(v-if='scope.row.level === 12') 资格丁
            el-table-column(prop='yearScore',header-align='center',align='center',label='俱乐部积分'  width="140" sortable)
            el-table-column(prop='enrollTime',header-align='center',align='center',label='注册时间' width="160"  sortable)
            el-table-column(prop='mbCount',header-align='center',align='center',label='会员数量' width='120' sortable)
            el-table-column(prop='gameCount',header-align='center',align='center',label='参赛次数' width='120' :show-overflow-tooltip='true' sortable)
            el-table-column(prop='status',header-align='center',align='center',label='状态' width="180")
                template(slot-scope="scope")
                    font(v-if='scope.row.status === 1' )
                      span.danger()
                      span() &nbsp; 待审批
                    font(v-if='scope.row.status === 2 && scope.row.mbCount >= 6')
                      span.success()
                      span() &nbsp; 正常
                    font(v-if='scope.row.status === 2 && scope.row.mbCount < 6')
                      span.warning()
                      span() &nbsp; 审批通过、人员未满
                    font(v-if='scope.row.status === 3')
                      span.warning()
                      span() &nbsp; 已拒绝
            el-table-column(prop='byx2',header-align='center',align='center',label='禁赛' :show-overflow-tooltip='true')
               template(slot-scope='scope')
                    font(v-if='scope.row.byx2 == 1')
                      span.danger()
                      span() &nbsp; 禁赛
                    font(v-if='scope.row.byx2 == 0')
                      span.success()
                      span() &nbsp; 未禁赛
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row.id)"   v-if="isAuth('ct:clubManage:detail')"  ) 查看基本信息
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id)" v-if="isAuth('ct:clubManage:update')"  ) 修改
                                el-menu-item(index="1-3" @click='memberManage(scope.row.id,scope.row)'  v-if="isAuth('ct:clubManage:memberlist')"   ) 成员管理
                                el-menu-item(index="1-4" @click='releaseClick(scope.row.id,scope.row)'  v-if="isAuth('ct:clubManage:hisotory')" ) 比赛记录
                                el-menu-item(index="1-4" @click='ViewDisputesClick(scope.row.id,scope.row)'  v-if="isAuth('ct:clubManage:hisotory')" ) 查看争议记录
                                el-menu-item(index="1-5" @click='suspend(scope.row.id)'  v-if="isAuth('ct:competition:set')"  ) 禁赛
                                el-menu-item(index="1-5" @click='deleteItem(scope.row.id)' v-if="isAuth('ct:competition:set')" ) 删除

        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //新建和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //查看
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='getDataList')
        //成员管理
        elEnrollInfo(v-if='elEnrollInfoVisible',ref="elEnrollInfo",@setLeader='getDataList')
        //比赛记录
        ViewDisputes(v-if='ViewDisputesVisible' ref="ViewDisputes" )
        gameInfo(v-if='gameInfoVisible' ref="gameInfo" @refreshDataList='getDataList')

        el-dialog(title="禁赛设置" :visible.sync="gamesVisible" :modal-append-to-body='false' :close-on-click-modal='true')
          el-form(:model="gameForm", :rules="gameRules", ref="gameForm")
            //- el-form-item(label="禁赛设置:")
            el-row()
              el-col(:span='24')
                el-form-item(label="竞赛时间:" prop='suspendStartTime')
                  el-date-picker( style='width:300px;'  v-model='gameForm.suspendStartTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
            el-form-item(label='原因说明:', prop='reason')
                el-input(type="textarea" :rows="5" resize="none" v-model="gameForm.reason" )
            el-row()
              el-col(:span='24' align='center')
                el-button(type="primary" @click="gameSubmit") 确认
                el-button(@click="gamesVisible=false" style='margin-left:40px;') 取消
</template>

<script>
import AddOrUpdate from './add-or-update'
import QueryView from './query-view'
import ElEnrollInfo from './el-enroll-info'
import GameInfo from './game-info'
import ViewDisputes from './ViewDisputes'
export default {
  name: 'ct-competition-clubList',
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      total: 0,
      startScoreMin: -999,
      StartScoreMax: 999,
      dataListLoading: '',
      tableData: [],
      checkedItems: [],
      isCollapse: true,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elEnrollInfoVisible: false,
      gameInfoVisible: false,
      ViewDisputesVisible: false,
      gamesVisible: false,
      matchId: '',
      dataForm: {
        startScore: '',
        endScore: '',
        name: '',
        chairman: '',
        chairmanId: '',
        level: null,
        publishTime: [],
        status: '',
        proviceId: '',
        cityId: '',
        matchName: null,
        userGroupId: null,
        ctType: null,
        applySize: null,
        projectType: null,
        matchStatus: null,
        matchStartTime: []
      },
      gameForm: {
        suspendStartTime: '',
        reason: ''
      },
      gameRules: '',
      banType: 'save',
      banId: '',
      cbId: '',
      proviceList: [],
      cityList: []
    }
  },
  components: {
    AddOrUpdate,
    QueryView,
    ElEnrollInfo,
    GameInfo,
    ViewDisputes
  },
  mounted () { },
  created () {
    this.getDataList()
    this.initProvice()
  },
  methods: {
    handleSelectionChange (val) {
      this.checkedItems = val
    },
    deleteItem (val) {
      let arr = []
      let ids = ''
      if (!val) { //批量删除按钮
        if (this.checkedItems.length < 1) {
          return this.$message.error('请选择至少一条数据进行删除操作！')
        }
        this.checkedItems.forEach(e => {
          arr.push(e.id)
        })
        ids = arr.join(',')
        this.checkedItems = []
      } else {
        ids = val
      }
      console.log(ids)

      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$showLoading()
        this.$http({
          url: this.$http.adornUrl(`/cbClub/delete`),
          method: 'post',
          params: this.$http.adornParams({
            ids: ids
          })
        }).then((data) => {
          console.log('删除俱乐部：', data)
          if (data && data.code === 0) {
            this.$message.success('删除成功！')
            this.getDataList()
            this.$showLoading('close')
          }
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 积分范围
    strHandleChange (val) {
      this.dataForm.startScore = val
    },
    endHandleChange (val) {
      this.dataForm.endScore = val
    },
    // 分页
    sizeChangeHandle (val) {
      this.pageSize = val
      this.getDataList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 初始化省份信息
    initProvice () {
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then(data => {
        this.proviceList = data && data.code === 0 ? data.list : []
      })
    },
    changeProvice () {
      this.cityList = []
      this.dataForm.cityId = ''
      // this.$http({
      //   url: this.$http.adornUrl('/dicProvinceCity/list'),
      //   method: 'get',
      //   params: this.$http.adornParams({
      //     proviceId: this.dataForm.proviceId
      //   })
      // }).then(data => {
      //   this.cityList = data && data.code === 0 ? data.list : []
      // })
    },
    //新建或修改
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    //查看
    queryHandle (id) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id)
      })
    },
    //成员管理
    memberManage (id, type) {
      this.elEnrollInfoVisible = true
      this.$nextTick(() => {
        this.$refs.elEnrollInfo.init(id, type)
      })
    },
    releaseClick (id, row) {
      this.gameInfoVisible = true
      this.$nextTick(() => {
        this.$refs.gameInfo.init(id, row)
      })
    },
    ViewDisputesClick (id, row) {
      this.ViewDisputesVisible = true
      this.$nextTick(() => {
        this.$refs.ViewDisputes.init(id, row)
      })
    },

    gameSubmit () {
      let startTime = ''
      let endTime = ''
      if (this.gameForm.suspendStartTime.length > 0) {
        startTime = new Date(this.gameForm.suspendStartTime[0]).getTime()
        endTime = new Date(this.gameForm.suspendStartTime[1]).getTime()
      }
      this.$http({
        url: this.$http.adornUrl(`/cbBan/${this.banType}`),
        method: 'post',
        data: {
          startTime: startTime,
          endTime: endTime,
          remark: this.gameForm.reason,
          id: this.banId,
          cbId: this.cbId
        }
      }).then(res => {
        if (res && res.code == 0) {
          this.gamesVisible = false
          this.$message.success('操作成功！')
          this.getDataList()
          // this.$http({
          //   url:this.$http.adornUrl(`/cbBanLog/save`),
          //   method:"post",
          //   data:{
          //     startTime:startTime,
          //     endTime:endTime,
          //     remark:this.gameForm.reason,
          //     cbId:this.cbId
          //   }
          // })
        } else {
          this.$message.error('操作失败！')
        }
      })
    },
    suspend (id) {
      console.log(id)
      this.cbId = id
      this.banType = 'save'
      this.banId = ''
      this.gameForm.suspendStartTime = []
      this.gamesVisible = true
      this.$nextTick(() => {
        if (this.$refs['gameForm']) {
          this.$refs['gameForm'].resetFields()
        }
      })
      // 查
      this.$http({
        url: this.$http.adornUrl(`/cbBan/getByCbId/${id}`)
      }).then(res => {
        if (res.bean) {
          console.log(res, 999)
          this.banId = res.bean.id
          this.gameForm.suspendStartTime = [
            res.bean.startTime,
            res.bean.endTime
          ]
          this.gameForm.reason = res.bean.remark
          this.banType = 'update'
        }
      })
    },
    getDataList () {
      console.log(this.dataForm)
      this.dataListLoading = true
      let data = {
        name: this.dataForm.name,
        chairman: this.dataForm.chairman,
        chairmanId: this.dataForm.chairmanId,
        level: this.dataForm.level,
        strScore: this.dataForm.startScore,
        endScore: this.dataForm.endScore,
        strDate: this.dataForm.publishTime[0] || '',
        endDate: this.dataForm.publishTime[1] || '',
        page: this.pageIndex,
        limit: this.pageSize,
        status: 2,
        provinceCodes: this.dataForm.proviceId.length === 0 ? null : this.dataForm.proviceId
      }
      this.$http({
        url: this.$http.adornUrl('/cbClub/list'),
        method: 'post',
        data: data
      }).then(data => {
        if (data && data.code === 0) {
          console.log(data)
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 导出
    exportExcel () {
      this.$http({
        url: this.$http.adornUrl('/cbClub/exportList'),
        method: 'post',
        data: {
          name: this.dataForm.name,
          chairman: this.dataForm.chairman,
          chairmanId: this.dataForm.chairmanId,
          level: this.dataForm.level,
          strScore: this.dataForm.strScore,
          endScore: this.dataForm.endScore,
          strDate: this.dataForm.publishTime[0] || '',
          endDate: this.dataForm.publishTime[1] || ''
        }
      }).then(data => {
        console.log('俱乐部列表信息：', data)
        if (data.code == 0) {
          console.log(data.list)
          if (data.list == null || data.list.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }
          let exportData = data.list
          for (let i of exportData) {
            i.level = {
              1: '甲A',
              2: '甲B',
              3: '乙A',
              4: '乙B',
              5: '丙A',
              6: '丙B',
              7: '丁A',
              8: '丁B',
              9: '资格'
            }[i.level]
            i.status = { 1: '待审批', 2: '已通过', 3: '已拒绝' }[i.status]
            i.byx2 = { 0: '正常', 1: '禁赛', 2: '禁训', 3: '禁赛/禁训' }[i.byx2]
          }
          console.log('导出的订单数据：', exportData)
          this.$export
            .excel({
              columns: [
                {
                  label: '俱乐部名称',
                  prop: 'name'
                },
                {
                  label: '地区',
                  prop: 'cityName'
                },
                {
                  label: '会长',
                  prop: 'chairman'
                },
                {
                  label: '会长账号',
                  prop: 'chairmanId'
                },
                {
                  label: '俱乐部等级',
                  prop: 'level'
                },
                {
                  label: '俱乐部积分',
                  prop: 'score'
                },
                {
                  label: '注册时间',
                  prop: 'enrollTime'
                },
                {
                  label: '会员数量',
                  prop: 'byx1'
                },
                {
                  label: '参赛次数',
                  prop: 'byx3'
                },
                {
                  label: '状态',
                  prop: 'status'
                },
                {
                  label: '禁赛',
                  prop: 'byx2'
                }
              ],
              data: exportData,
              title: '俱乐部列表信息'
            })
            .then(() => {
              this.$message.success('导出表格成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped >
/* 操作三点 菜单样式 */
@import '../../../../css/opr3dot.css';

.inputWidth {
  width: 190px;
}
</style>
<style >
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
.el-input-number--mini .el-input__inner {
  padding-left: 25px;
  padding-right: 25px;
}
.el-input-number--mini .el-input-number__decrease,
.el-input-number--mini .el-input-number__increase {
  width: 24px;
  font-size: 12px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
